import React, { useCallback, useEffect } from 'react';
import SearchField from 'components/Field/SearchField/SearchField';
import useFilters from 'hooks/useFilters';
import WarehouseFilter from 'components/WarehouseFilter/WarehouseFilter';
import AgencyChooser from 'components/AgencyChooser/AgencyChooser';
import Portal from 'components/Portal/Portal';
import FiltersBar from 'components/FiltersBar/FiltersBar';
import './retry-shipments-filters-bar.scss';
import RetryableShipmentsTotalsBar from 'components/RetryableShipmentsTotalsBar/RetryableShipmentsTotalsBar';
import { ORIGINS } from 'constants/constants';

export default function RetryShipmentsFiltersBar({
  query,
  totals,
  userOrigin,
  onChangeQuery = () => {},
  onFiltersChange = () => {},
}) {
  const isSorter = userOrigin === ORIGINS.SORTER.slug;

  const [filters, setFilters] = useFilters(
    'retryShipmentsFilters',
    onFiltersChange,
    {
      agency_id: '',
      warehouse_id: '',
    },
  );

  const updateAgency = useCallback(
    ({ id }) => {
      setFilters({ ...filters, agency_id: id });
    },
    [filters, setFilters],
  );

  const removeAgency = useCallback(() => {
    setFilters({ ...filters, agency_id: null });
  }, [filters, setFilters]);

  const updateWarehouse = useCallback(
    (event, { value }) => setFilters({ ...filters, warehouse_id: value }),
    [filters, setFilters],
  );

  const updateWarehouseAndAgency = useCallback(
    (warehouse_id, agency_id) =>
      setFilters({ ...filters, warehouse_id, agency_id }),
    [filters, setFilters],
  );

  useEffect(() => {
    !!isSorter && removeAgency();
    //eslint-disable-next-line
  }, [userOrigin]);

  return (
    <FiltersBar>
      <div>
        {totals && (
          <RetryableShipmentsTotalsBar
            filters={filters}
            totals={totals}
            canChooseAgency={!isSorter}
            onSelectAgency={updateWarehouseAndAgency}
          />
        )}
      </div>
      <FiltersBar.Row>
        <Portal.In target="page-header-right">
          <SearchField
            value={query}
            placeholder="Buscar…"
            onChange={onChangeQuery}
          />
        </Portal.In>
        <WarehouseFilter
          isSorter={isSorter}
          clearable={false}
          currentWarehouse={filters?.warehouse_id}
          onChangeWarehouse={updateWarehouse}
        />
        {!isSorter && (
          <AgencyChooser
            showLabel
            currentAgencyId={filters?.agency_id}
            onSelected={updateAgency}
          />
        )}
      </FiltersBar.Row>
    </FiltersBar>
  );
}
